import { Dialog } from '../Dialog';
import { withUserID } from '../withUserID';
import { UserBase } from './UserBase';
export var User = withUserID(UserBase, Dialog);
